import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Upload, Modal, Button, Row, Col } from 'antd';
import ImgCrop from 'antd-img-crop';
import { SAVE_IMAGES_FROM } from '../../state/lease_contract/types';
import Resizer from 'react-image-file-resizer';
import { IMAGE_SIZE } from '../../config/constants/imageSize';
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import imgIdFront from '../../images/img-id-front.svg';
import imgIdBack from '../../images/img-id-back.svg';

const ImageUpload = ({ id, formName, contractFormData, saveImage, images, imageSide, label, validate }) => {

  const [newImage, setNewImage] = useState('');
  const [isUploaded, setFrontIsUploaded] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');

  useEffect(() => {
    if (!contractFormData.editForm && Object.keys(images).length !== 0) {
      if (`${formName}_0_${imageSide}` === id && images[id]) {
        setNewImage(images[id]);
        setFrontIsUploaded(true);
      } else if (images[`${formName}_${id}_${imageSide}`]) {
        setNewImage(images[`${formName}_${id}_${imageSide}`]);
        setFrontIsUploaded(true);
      }
    };
  }, []);

  const uploadButton = (
    <div>
      <img className="px-3" src={(`${label}` == 'frontal') ? imgIdFront : imgIdBack} alt="" />
      <div className="fs-xs text-terciary"> {label}</div>
    </div>
  );

  const preview = (img) => {
    setPreviewImage(img);
    setModalVisible(true);
  };

  const deleteImg = () => {
    setNewImage('');
    setFrontIsUploaded(false);
    validate();
    if (`${formName}_0_${imageSide}` === id) {
      delete images[id];
    } else {
      delete images[`${formName}_${id}_${imageSide}`];
    }
  };

  const resizeFile = (file) => new Promise(resolve => {
    Resizer.imageFileResizer(
      file,
      IMAGE_SIZE.MAX_WIDTH,
      IMAGE_SIZE.MAX_HEIGHT,
      IMAGE_SIZE.FORMAT,
      IMAGE_SIZE.QUALITY,
      IMAGE_SIZE.ROTATION,
      uri => { resolve(uri); },
      IMAGE_SIZE.OUTPUT_TYPE,
    );
  });

  const uploadImageFile = (file) => {
    const reader = new FileReader();
    reader.onload = async function (fileLoadedEvent) {
      const base64 = fileLoadedEvent.target.result;
      const base64Response = await fetch(base64);
      const blob = await base64Response.blob();
      const image = await resizeFile(blob);
      setNewImage(image);
      setFrontIsUploaded(true);
      if (`${formName}_0_${imageSide}` === id) {
        saveImage({ ...images, [id]: image });
        validate();
      } else {
        saveImage({ ...images, [`${formName}_${id}_${imageSide}`]: image });
        validate();
      }
    };
    reader.readAsDataURL(file);
  };

  const dummyRequest = ({ onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  return (
    <React.Fragment>
      <ImgCrop 
        rotate 
        aspect={1.5 / 1}
      >
        <Upload
          name="avatar"
          listType="picture-card"
          className="avatar-uploader"
          accept='image/png, image/jpeg, image/jpg'
          customRequest={dummyRequest}
          showUploadList={false}
          multiple={false}
          action={(file) => { uploadImageFile(file); }}
        >
          {isUploaded ? <img src={newImage} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
        </Upload>
      </ImgCrop>
      {
        isUploaded &&
        <Row className="display:inline">
          <Col xs={24} className="d-flex align-items-center mb-2">
            <Button type="link" onClick={() => preview(newImage)}><EyeOutlined /></Button>
            <Button type="link" onClick={() => deleteImg()}><DeleteOutlined /></Button>
          </Col>
        </Row>
      }
      <Modal
        visible={modalVisible}
        title={`Imagen ${label} cédula de identidad`}
        footer={null}
        onCancel={() => (setModalVisible(false))}
      >
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </React.Fragment>
  );
};

ImageUpload.propTypes = {
  id: PropTypes.any.isRequired,
  contractFormData: PropTypes.object.isRequired,
  saveImage: PropTypes.func.isRequired,
  images: PropTypes.object.isRequired,
  imageSide: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  formName: PropTypes.string,
  validate: PropTypes.func.isRequired,
};

const data = (state) => ({
  contractFormData: state.contract.contractFormData,
  images: state.contract.images,
});

const actions = (dispatch) => ({
  saveImage: (data) =>
    dispatch({ type: SAVE_IMAGES_FROM, payload: { ...data } }),
});

export default connect(data, actions)(ImageUpload);